import { __assign, __read } from "tslib";
import React, { useRef, useState, Fragment } from 'react';
import Select from 'react-select';
import { Box, Flex, Position, Popover } from '@marvelapp/ui';
import { colors, fonts } from '@marvelapp/theme';
import { useOnClickOutside } from '@marvelapp/hooks';
import { SpecsValue, SpecsPanelLabel } from '@marvelapp/ui-internal';
import { CaretIcon } from './icons';
var selectStyles = {
    control: function () { return ({
        display: 'none',
    }); },
    menu: function () { return ({
        minWidth: 120,
    }); },
    menuList: function () { return ({
        paddingBottom: 0,
        paddingTop: 0,
    }); },
    option: function (provided, state) { return (__assign(__assign({}, provided), { backgroundColor: state.isSelected ? colors.marvel : 'none', color: state.isSelected ? colors.white : colors.slate, cursor: 'pointer', fontFamily: fonts[0], fontSize: 12, ':hover': {
            color: state.isSelected ? colors.white : colors.licorice,
            backgroundColor: state.isSelected ? colors.marvelDark : colors.snowDark,
        }, '&:first-child': {
            borderRadius: '3px 3px 0 0',
        }, '&:last-child': {
            borderRadius: '0 0 3px 3px',
        } })); },
};
export default function PanelSelect(_a) {
    var label = _a.label, onChange = _a.onChange, options = _a.options, testId = _a.testId, value = _a.value;
    var ref = useRef();
    var selectedItem = options.filter(function (object) { return object.value === value; });
    var _b = __read(useState(selectedItem[0]), 2), innerValue = _b[0], setValue = _b[1];
    var _c = __read(useState(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    var toggleOpen = function () {
        setIsOpen(!isOpen);
    };
    var onSelectChange = function (object) {
        onChange(object.value);
        setValue(object);
        toggleOpen();
    };
    useOnClickOutside(ref, function () {
        setIsOpen(false);
    });
    return (React.createElement(Fragment, null,
        React.createElement(SpecsPanelLabel, null, label),
        React.createElement("div", { ref: ref },
            React.createElement(Dropdown, { isOpen: isOpen, onClose: toggleOpen, target: React.createElement(SpecsValue, { fontFamily: 0, isDisabled: true, onClick: toggleOpen },
                    React.createElement(Flex, { alignItems: "center", cursor: "pointer" },
                        React.createElement(Box, { hoverBoxShadow: "borders.bottom", marginRight: "6px" }, innerValue ? innerValue.label : 'Select'),
                        React.createElement(Box, { transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' },
                            React.createElement(CaretIcon, { width: 6 })))), testId: testId },
                React.createElement(Select, { classNamePrefix: "react-select", hideSelectedOptions: false, menuIsOpen: true, onChange: onSelectChange, options: options, styles: selectStyles, value: innerValue })))));
}
function Dropdown(_a) {
    var children = _a.children, isOpen = _a.isOpen, target = _a.target, testId = _a.testId;
    return (React.createElement(Position, { zIndex: isOpen ? 1000 : undefined },
        target,
        React.createElement(Popover, { borderRadius: "4px", boxShadow: "popover.raised", "data-testid": testId, distance: 10, isActive: isOpen, position: "bottomLeft", showOn: "custom" }, children)));
}
